import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';

interface StatusButtonProps {
  status: string;
  icon: React.ReactNode;
  onClick: () => void;
  description: string | React.ReactNode;
  loading: boolean;
  isOn?: boolean;
}
export const StatusButton = (props: StatusButtonProps) => {
  const { status, icon, onClick, description, loading, isOn } = props;
  const theme = useTheme();

  const isDisabled = status !== 'On';

  const getStatusColor = () => {
    if (!isOn) {
      return {
        bg: theme.palette?.neutral?.dark,
        color: theme.palette?.gray?.main,
      };
    }
    switch (status) {
      case 'On':
        return {
          bg: theme.palette.secondary.main,
          color: theme.palette.primary.main,
        };
      case 'Off':
        return {
          bg: theme.palette?.neutral?.dark,
          color: theme.palette?.gray?.main,
        };
      case 'Error':
        return {
          bg: theme.palette.error.main,
          color: theme.palette.error.contrastText,
        };
      default:
        return {
          bg: theme.palette.primary.light,
          color: theme.palette.primary.main,
        };
    }
  };

  const { bg, color } = getStatusColor();
  return (
    <Button
      onClick={onClick}
      fullWidth
      disabled={isDisabled}
      style={{
        backgroundColor: bg,
        borderRadius: '0.5rem',
        display: 'grid',
        gridTemplateColumns: '1.5fr 3fr',
        alignItems: 'center',
        border: 'none',
        textAlign: 'center',
        padding: '0.5rem 1rem',
        gap: '1rem',
        margin: '0.5rem 0',
        cursor: 'default',
      }}
      disableRipple={true}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <Box
            justifySelf={'end'}
            alignItems="center"
            display={'flex'}
            color={color}
          >
            {icon}
          </Box>
          <Typography justifySelf={'start'} textAlign={'left'} color={color}>
            {description}
          </Typography>
        </>
      )}
    </Button>
  );
};
